export default "__VITE_ASSET__aeIVT3Yc__"